<template>
  <v-card>
    <v-card-text>
      <v-row dense>
        <v-col cols="3" lg="2" align-self="center">
          計測項目
        </v-col>
        <v-col cols="9" lg="10">
          <v-select
            density="compact" variant="outlined" hide-details="auto"
            :items="MeasurementList" v-model:model-value="measurement">
            <template v-slot:prepend-inner>
              <v-icon size="small" class="d-block pt-0">mdi-home-thermometer-outline</v-icon>
            </template>
          </v-select>
        </v-col>
      </v-row>

      <v-row dense justify="end">
        <v-col cols="3" lg="2" align-self="center">
          計測日時
        </v-col>
        <v-col cols="9" lg="4">
          <vue-date-picker
            :clearable="false"
            locale="ja"
            week-start="0"
            :enable-time-picker="false"
            auto-apply
            :teleport="true"
            v-model="date"
            :format="formatDate"
          ></vue-date-picker>
        </v-col>

        <v-col cols="5" lg="3">
          <v-select
            density="compact" variant="outlined" hide-details="auto"
            :items="HourList" v-model:model-value="hour">
            <template v-slot:prepend-inner>
              <v-icon size="small" class="d-block pt-0">mdi-clock-outline</v-icon>
            </template>
          </v-select>
        </v-col>
        <v-col cols="4" lg="3">
          <v-switch density="compact" hide-details="auto" class="ms-3" color="primary"
            label="連動" v-model="isSyncDateTime"></v-switch>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-btn style="position: absolute; left: 5%; z-index: 1;" class="mt-8"
            density="comfortable" icon="mdi-chevron-left" v-on:click="showPrev"></v-btn>
          <v-btn style="position: absolute; right: 5%; z-index: 1;" class="mt-8"
            density="comfortable" icon="mdi-chevron-right" v-on:click="showNext"></v-btn>

          <div class="chart" v-bind:id="'chart' + index"></div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { defineComponent, inject, ref, onMounted, watch } from 'vue';

import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

import Plotly from 'plotly.js-dist-min';

import axios from 'axios';

export default defineComponent({
  name: 'ContourPlots',

  props: {
    index: { type: Number },


    xMin: { type: Number },
    xMax: { type: Number },
    yMin: { type: Number },
    yMax: { type: Number },

    devices: {
      type: Array,

      default(/* rawProps */) {
        return [];
      }
    },


    isColorGaugeRangeFixed: {
      type: Boolean,
      default: false
    },

    colorGaugeMin: {
      type: Number,
      default: 0
    },
    colorGaugeMax: {
      type: Number,
      default: 0
    }
  },

  components: {
    VueDatePicker
  },

  setup(props) {

    const Devices = new Map();


    const MeasurementList = [
      { title: "室温（℃）", value: "ch23" },
      { title: "湿度（%RH）", value: "ch24" },
      { title: "CO2濃度（ppm）", value: "ch25" },
      { title: "飽差（HD）（g/m3）", value: "ch63" },
      { title: "露点温度（℃）", value: "ch64" },
      { title: "灰色かび発病リスク", value: "ch21" },
      { title: "土壌温度（℃）", value: "ch71" },
      { title: "土壌水分量（%VWC）", value: "ch72" },
      { title: "RSSI（dBm）", value: "ch19" }
    ];

    const HourList = [
      { title: "00時", value: "00" },
      { title: "01時", value: "01" },
      { title: "02時", value: "02" },
      { title: "03時", value: "03" },
      { title: "04時", value: "04" },
      { title: "05時", value: "05" },
      { title: "06時", value: "06" },
      { title: "07時", value: "07" },
      { title: "08時", value: "08" },
      { title: "09時", value: "09" },
      { title: "10時", value: "10" },
      { title: "11時", value: "11" },
      { title: "12時", value: "12" },
      { title: "13時", value: "13" },
      { title: "14時", value: "14" },
      { title: "15時", value: "15" },
      { title: "16時", value: "16" },
      { title: "17時", value: "17" },
      { title: "18時", value: "18" },
      { title: "19時", value: "19" },
      { title: "20時", value: "20" },
      { title: "21時", value: "21" },
      { title: "22時", value: "22" },
      { title: "23時", value: "23" }
    ];


    const MinuteList = [
      '00',
      '05',
      '10',
      '15',
      '20',
      '25',
      '30',
      '35',
      '40',
      '45',
      '50',
      '55'
    ];


    const measurement = ref(MeasurementList[0].value);

    const date = ref(new Date());
    const hour = ref(date.value.getHours().toString().padStart(2, '0'));
    const timelineIndex = ref(0);

    const isSyncDateTime = ref(true);

    const sharedDate = inject('shared-date');
    const sharedHour = inject('shared-hour');
    const sharedTimelineIndex = inject('shared-chart-timeline-index');


    const formatDate = (date) => {

      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');

      return year + "-" + month + "-" + day;
    };


    onMounted(() => {

      props.devices.forEach((device) => {

        Devices.set(device.id.toString(), {
          houseID: device.id.toString(),
          positionX: device.x,
          positionY: device.y
        });

      });


      date.value = sharedDate.value;
      hour.value = sharedHour.value;
      timelineIndex.value = sharedTimelineIndex.value;


      var positionsX = [];
      var positionsY = [];
      var hovertext = [];

      Devices.forEach((value) => {
        positionsX.push(value.positionX);
        positionsY.push(value.positionY);
        hovertext.push('BOX ID: ' + value.houseID);
      });

      Plotly.newPlot('chart' + props.index, {

        frames: [
          {
            name: MinuteList[0],
            data: [
              {
                // レイアウト崩れ防止のためカラーバーが初期表示される状態にする
                z: [0, 0, 0, 0, 0, 0, 0, 0, 0]
              }
            ]
          }
        ],

        data: [
          {
            type: 'contour',

            opacity: 0.6,

            colorbar: {
              orientation: 'h',
              thickness: 10,
              len: 0.8,
              y: -0.2
            },
            colorscale: 'YlOrRd',
            reversescale: true,

            zauto: !props.isColorGaugeRangeFixed,
            zmin: props.colorGaugeMin,
            zmax: props.colorGaugeMax,

            ncontours: 30,

            x: positionsX,
            y: positionsY,

            hoverinfo: 'none'
          },

          {
            type: 'scatter',

            mode: 'markers+text',
            marker: {
              size: 8,
              color: '#3F51B5' // indigo
            },

            x: positionsX,
            y: positionsY,

            hoverinfo: 'text',
            textposition: 'top',
            textfont: {
              size: 13
            },
            hovertext: hovertext
          }
        ],

        layout: {
          margin: {
            t: 0,
            r: 0,
            b: 0,
            l: 0
          },

          dragmode: false,

          sliders: [{
            len: 0.7,
            x: 0.15,
            y: 1.35,
            pad: {
              t: 30
            },

            currentvalue: {
              visible: false
            },

            steps: [
              { label: MinuteList[0] + '分', method: 'animate', args: [[MinuteList[0]]] },
              { label: MinuteList[1] + '分', method: 'animate', args: [[MinuteList[1]]] },
              { label: MinuteList[2] + '分', method: 'animate', args: [[MinuteList[2]]] },
              { label: MinuteList[3] + '分', method: 'animate', args: [[MinuteList[3]]] },
              { label: MinuteList[4] + '分', method: 'animate', args: [[MinuteList[4]]] },
              { label: MinuteList[5] + '分', method: 'animate', args: [[MinuteList[5]]] },
              { label: MinuteList[6] + '分', method: 'animate', args: [[MinuteList[6]]] },
              { label: MinuteList[7] + '分', method: 'animate', args: [[MinuteList[7]]] },
              { label: MinuteList[8] + '分', method: 'animate', args: [[MinuteList[8]]] },
              { label: MinuteList[9] + '分', method: 'animate', args: [[MinuteList[9]]] },
              { label: MinuteList[10] + '分', method: 'animate', args: [[MinuteList[10]]] },
              { label: MinuteList[11] + '分', method: 'animate', args: [[MinuteList[11]]] }
            ]
          }],

          xaxis: {
            range: [props.xMin, props.xMax],
            dtick: 1,
            zeroline: false,
            showticklabels: false,
            ticks: ''
          },

          yaxis: {
            scaleanchor: 'x',

            range: [props.yMin, props.yMax],
            dtick: 1,
            zeroline: false,
            showticklabels: false,
            ticks: ''
          }
        },

        config: {
          displayModeBar: true,
          modeBarButtonsToRemove: [
            'zoom2d',
            'pan2d',
            'select2d',
            'lasso2d',
            'zoomIn2d',
            'zoomOut2d',
            'autoScale2d',
            'resetScale2d'
          ],
          displaylogo: false
        }

      });

      document.getElementById('chart' + props.index).on('plotly_sliderchange', (e) => {
        if (e.interaction) {
          timelineIndex.value = e.slider.active;
        }
      });

      Plotly.animate('chart' + props.index, [MinuteList[0]]);

      watch(props, () => {

        const graphDiv = document.getElementById('chart' + props.index);

        graphDiv.data[0].zauto = !props.isColorGaugeRangeFixed;
        graphDiv.data[0].zmin = props.colorGaugeMin;
        graphDiv.data[0].zmax = props.colorGaugeMax;

        Plotly.update('chart' + props.index, graphDiv.data, graphDiv.layout);

      });


      showGraph();

      watch(measurement, showGraph);

      watch(date, () => {

        if (isSyncDateTime.value) {
          sharedDate.value = date.value;
        }

        showGraph();
      });

      watch(hour, () => {

        if (isSyncDateTime.value) {
          sharedHour.value = hour.value;
        }

        showGraph();
      });

      watch(timelineIndex, setChartTimelineIndex);

      watch(isSyncDateTime, () => {
        if (isSyncDateTime.value) {
          date.value = sharedDate.value;
          hour.value = sharedHour.value;
          timelineIndex.value = sharedTimelineIndex.value;
        }
      });


      watch(sharedDate, () => {
        if (isSyncDateTime.value) {
          date.value = sharedDate.value;
        }
      });

      watch(sharedHour, () => {
        if (isSyncDateTime.value) {
          hour.value = sharedHour.value;
        }
      });

      watch(sharedTimelineIndex, () => {
        if (isSyncDateTime.value) {
          timelineIndex.value = sharedTimelineIndex.value;
        }
      });

    });


    const showGraph = () => {

      fetchMeasurementValues(
        measurement.value, formatDate(date.value), hour.value
      ).then((values) => {

        var frames = [];

        MinuteList.forEach((minute) => {
          var frame = {
            name: minute,
            data: [
              { z: [] },
              { text: [] }
            ]
          };

          // データが揃っている場合のみ表示する
          if (Object.keys(values[minute]).length === Devices.size) {

            for (const key of Devices.keys()) {
              frame.data[0].z.push(values[minute][key]);
              frame.data[1].text.push(values[minute][key]);
            }

          } else {
            // レイアウト崩れ防止のためカラーバーが表示されたままの状態にする
            frame.data[0].z = [0, 0, 0, 0, 0, 0, 0, 0, 0];
          }

          frames.push(frame);
        });

        Plotly.addFrames('chart' + props.index, frames);


        Plotly.animate('chart' + props.index, [MinuteList[timelineIndex.value]]);

      }).catch((/* error */) => {

        // 別アカウント作成のURLでのアクセスはログアウトする
        window.sessionStorage.clear();
        window.location.reload();

      });

    };

    const fetchMeasurementValues = async (measurement, date, hour) => {

      var values = {};

      MinuteList.forEach((minute) => {
        values[minute] = {};
      });

      for (const deviceID of Devices.keys()) {

        const response = await axios.get(
          `https://trial.agrilog.jp/v2` +
          `/devices/${ Devices.get(deviceID).houseID }` +
          `/environment/raw?data_key=${ measurement }` +
          `&start_time=${ date }+${ hour }:00:00&end_time=${ date }+${ hour }:59:59`,
          { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem("token") }}
        );

        response.data.data_list.forEach((data) => {

          const minute = data.datetime.substring(14, 16);
          values[minute][deviceID] = data.value;

        });

      }

      return values;

    };

    const setChartTimelineIndex = () => {

      if (isSyncDateTime.value) {
        sharedTimelineIndex.value = timelineIndex.value;
      }

      Plotly.animate('chart' + props.index, [MinuteList[timelineIndex.value]], {
        transition: {
          duration: 0
        }
      });

    };


    const showPrev = () => {

      if (timelineIndex.value > 0) {
        timelineIndex.value--;
      } else {

        if (hour.value === "00") {

          const d = date.value;
          date.value = new Date(d.getFullYear(), d.getMonth(), d.getDate() - 1);

          hour.value = "23";

        } else {
          hour.value = HourList[parseInt(hour.value, 10) - 1].value;
        }

        timelineIndex.value = 11;
      }

    };

    const showNext = () => {

      if (timelineIndex.value < 11) {
        timelineIndex.value++;
      } else {

        if (hour.value === "23") {

          const d = date.value;
          date.value = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);

          hour.value = "00";

        } else {
          hour.value = HourList[parseInt(hour.value, 10) + 1].value;
        }

        timelineIndex.value = 0;
      }

    };


    return {
      MeasurementList,
      HourList,
      measurement,
      date,
      hour,
      isSyncDateTime,
      formatDate,
      showPrev,
      showNext
    }
  }
})
</script>

<style scoped>
  .chart {
    height: 380px;
  }
</style>
